//migrate FilePond functionality to here.
// Import React FilePond
import React, { Component } from 'react';
import { FilePond, FileStatus } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import { SASSY as Sassy } from "../api/lib/sassy";
import FeedbackModal from './FeedbackModal';
import CSVTemplate from '../Format.csv';

export default class CSVUploader extends Component {
  constructor () {
    super();
    this.state = {
      sassyApi: new Sassy(),
      files: [],
      data: this.emptyDataset(),
      assetUrl: null
    }
  }

  emptyDataset() {
    return {
      headers: [],
      rows: [],
      resultHeaders: [],
      resultRows: [],
      stats: []
    };
  }

  onAddFile(err, { file } = {}) {
    if (err) {
      console.error(err);
    }

    let reader = new FileReader();

    reader.addEventListener("load", (event) => {

      try {
        this.deserializeCSV(reader.result);
      } catch (err) {
        console.error(err);
        this.onParseError(err, file.name)
        // this.pond.removeFiles();
      }
    }, { passive: true, once: true });

    reader.onerror = (err) => console.error(err)

    reader.readAsText(file);
  }

  onRemoveFile(err, file) {
    let data = this.emptyDataset()
    this.props.onRemove({ data });
    this.setState({ ...this.state, data });
  }

  onParseError(err, filename = "") {
    // do some basic error handling for invalid CSVs
    let { message = '' } = err;

    if (message === "Cannot read property 'prop' of undefined") {
      message = `Make sure the first line of your CSV matches the provided template.`;
    }

    if (!filename.includes("csv")) {
      message = `Please upload a valid CSV file.`;
    }

    this.feedback.open(filename, message)
  }

  showExampleReport() {
    this.state.files.push(CSVTemplate)
  }

  deserializeCSV(rawText) {
    let dataObject = rawText.split('\n').map(row => row.trim().split(','));
    let [headers, ...rows] = dataObject;

    var unquote = (str = "") => {
      return str.trim()
        .replace(/(\\+\w{1})/g, '')
        .replace(/(^")|("$)/g, '')
        .replace(/\./g, " ");
    };

    // headers = this.convertGoogleSheet(headers);
    // this.checkCSVHeaders(headers);

    headers = headers.map(h => ({ prop: unquote(h).toLowerCase(), label: unquote(h) })).slice(0, 5);

    rows = rows.map(this.replaceSmartQuotes).map(([id, a, b, c, d]) => {
      return {
        [headers[0].prop]: (unquote(id)),
        [headers[1].prop]: (unquote(a)),
        [headers[2].prop]: (unquote(b)),
        [headers[3].prop]: (unquote(c)),
        [headers[4].prop]: (unquote(d)),
      };
    });

    this.createResultSet({ headers, rows });
  }

  appendSegment = (response) => {
    const { sassyApi: Sassy } = this.state;
    let segment;
    let { "personal importance": Qnum1, "worry": Qnum2, "personal harm": Qnum3, "future generations": Qnum4 } = response;
    let { "important": qnum1, "worry": qnum2, "personal": qnum3, "future": qnum4 } = response;
    let numerical = Object.values(response).slice(1).every(q => {
      let v = q.match(/\d/gi);
      return v;
    })
    if (numerical) {
      let [Question1, Question2, Question3, Question4] = Object.values(response).slice(1).map(q => {
        let v = +q.match(/\d/gi)[0];
        return v;
      })
      segment = Sassy.computeSegment({ Question1, Question2, Question3, Question4 });
    } else {
      let [Question1, Question2, Question3, Question4] =
        [Qnum1 || qnum1, Qnum2 || qnum2, Qnum3 || qnum3, Qnum4 || qnum4].map((resp = "", index) => {
          return Sassy.responseTextToValue(resp, index);
        });
      segment = Sassy.computeSegment({ Question1, Question2, Question3, Question4 });
    }


    // let [timestamp, Question1, Question2, Question3, Question4] = Object.values(response);

    return { ...response, segment };
  }

  checkCSVHeaders(headers) {
    let [template2017, template2018] = [
      ["caseid", "id", "personal importance", "worry", "personal harm", "future generations"],
      ["casenumber", "important", "worry", "personal", "future"]
    ];

    headers = headers.map(h => h.prop);

    const is2017 = headers.every(header => template2017.includes(header))
    const is2018 = headers.every(header => template2018.includes(header))

    if (!is2017 && !is2018) {
      // return new Error(`CSV headers must be: ${template2018.join(', ')}.`);
      throw (new Error(`CSV headers must be: ${template2018.join(', ')}.`))
    };
  }

  convertGoogleSheet(headers) {
    if (headers.includes('"Timestamp"')) {
      headers = ["casenumber", "important", "worry", "personal", "future"];
    }
    return headers;
  }

  replaceSmartQuotes(row) {
    return row.map(value => value.replace(/’/g, "'"));
  }

  createResultSet({ headers, rows }) {
    let resultHeaders = headers.slice(0);
    resultHeaders.push({ prop: "segment", label: "SASSY Segment" });
    let resultRows = rows.map(this.appendSegment);
    let stats = this.calculateStats(resultRows);
    let assetUrl = this.createAsset({ resultHeaders, resultRows });
    let data = { headers, rows, resultHeaders, resultRows, stats };
    this.props.onResults({ data, assetUrl, stats });
    this.setState({ ...this.state, data, assetUrl });
  }

  calculateStats(results = []) {
    let aggregation = results.reduce((segments, row, rowIndex, rows) => {
      const { segment } = row;
      const segmentNames = ["Alarmed", "Concerned", "Cautious", "Disengaged", "Doubtful", "Dismissive"];

      if (!segment) {
        return segments;
      } else if (!segments.has(segment)) {
        segmentNames.map(segment => segments.set(segment, 0));
      }

      let count = segments.get(segment);
      segments.set(segment, count + 1);

      return segments;
    }, new Map());

    return [...aggregation].map(([name, value]) => ({ name, value }));
  }

  createAsset({ resultHeaders, resultRows }) {
    let header = resultHeaders.map(h => `"${h.label.trim()}"`).join(',');
    let rows = resultRows.map(r => Object.values(r).map((v = "") => `"${v.trim()}"`).join(',')).join('\r');
    let asset = new Blob([[header, rows].join('\r')], { type: 'text/csv', endings: "native" });
    let downloadUrl = window.URL.createObjectURL(asset);

    return downloadUrl;
  }

  render() {
    let prompt = `<span class="filepond--label-action">Click here to upload a CSV.</span>`
    return <div className={this.props.hidden ? "hidden" : "csv-uploader"}>
      <FilePond
        ref={ref => this.pond = ref}
        allowMultiple={false}
        instantUpload={false}
        server="."
        labelIdle={prompt}
        labelFileAdded='Added'
        dropOnPage={true}
        dropValidation={false}
        iconProcess='<span></span>'
        acceptedFileTypes={['text/csv', 'application/octet-stream']}
        fileValidateTypeLabelExpectedTypesMap={{ 'text/csv': '.csv', 'application/octet-stream': '.csv' }}
        onerror={console.error}
        onprocess={console.log}
        onaddfile={(err, file) => this.onAddFile(err, file)}
        onremovefile={(err, file) => this.onRemoveFile(err, file)}
        onupdatefiles={fileItems => {
          // Set currently active file objects to this.state
          this.setState({
            files: fileItems.map(fileItem => fileItem.file)
          });
        }}>
        {/* Set current files using the <File/> component */}
        {this.state.files.map(file => (
          <FileStatus key={file} src={file} />
        ))}
      </FilePond>
      <FeedbackModal ref={ref => this.feedback = ref}></FeedbackModal>
    </div>;
  }
}